// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------
import React from 'react';
import ErrorMessage from './../../components/ErrorMessage';

import Styles from './messages.module.scss';

interface MessagePropTypes {
    errorMessage?: string;
    successMessage?: string;
}

export default function Message(props: MessagePropTypes) {
    return (
        <>
            <span className={Styles.successMessage}>
                {props.successMessage ? props.successMessage : undefined}
            </span>
            <ErrorMessage message={props.errorMessage ? props.errorMessage : undefined} />
        </>);

}
